import { F as Form, d as FormV2, e as FormV3 } from './FormV3-0702cb53.js';
export { F as Form, c as FormPopup, d as FormV2, e as FormV3, I as InnerFormV3, S as StyledForm, a as StyledFormItem, b as StyledLabel } from './FormV3-0702cb53.js';
import { H as Heading } from './Heading-e29a867a.js';
export { H as Heading, S as StyledHeading } from './Heading-e29a867a.js';
import { I as Image } from './Image-b56e679c.js';
export { I as Image, a as ImageWrapper } from './Image-b56e679c.js';
import { P as Paragraph } from './Paragraph-ab5572bb.js';
export { P as Paragraph, S as StyledParagraph } from './Paragraph-ab5572bb.js';
import { Y as Youtube } from './Youtube-a2db488f.js';
export { Y as Youtube } from './Youtube-a2db488f.js';
import { S as Slider, a as SliderV2 } from './SliderV2-e48980f6.js';
export { S as Slider, a as SliderV2 } from './SliderV2-e48980f6.js';
import { P as PbRow } from './PbRow-9686de95.js';
export { P as PbRow } from './PbRow-9686de95.js';
import { P as PbSection } from './PbSection-2f7fdb4a.js';
export { P as PbSection } from './PbSection-2f7fdb4a.js';
import { P as PbCol } from './PbCol-8fdaf318.js';
export { P as PbCol } from './PbCol-8fdaf318.js';
import { S as Spacer } from './Spacer-7f4db015.js';
export { S as Spacer } from './Spacer-7f4db015.js';
import { P as PbDivider } from './PbDivider-c33bf61b.js';
export { P as PbDivider } from './PbDivider-c33bf61b.js';
import { P as PbContainer } from './PbContainer-af335ddc.js';
export { P as PbContainer } from './PbContainer-af335ddc.js';
import { B as ButtonV1, a as ButtonV2 } from './ButtonV2-6506d594.js';
export { B as ButtonV1, a as ButtonV2, b as ButtonWrapper } from './ButtonV2-6506d594.js';
import { P as PbIcon } from './PbIcon-311bf624.js';
export { P as PbIcon } from './PbIcon-311bf624.js';
import { H as Header, L as Logo, M as Menu, b as MenuItem, a as MenuCol } from './Logo-3c338840.js';
export { H as Header, L as Logo, M as Menu, a as MenuCol, b as MenuItem } from './Logo-3c338840.js';
import { b as Tab, T as TabItem } from './Tab-4872aa71.js';
export { b as Tab, c as TabHeadWrapper, T as TabItem, a as TabItemHead } from './Tab-4872aa71.js';
import { H as HtmlCode } from './HtmlCode-fbb66a8c.js';
export { H as HtmlCode } from './HtmlCode-fbb66a8c.js';
import { L as List, a as ListItem, c as ListItemContent, b as ListItemIcon } from './ListItemContent-24140036.js';
export { L as List, a as ListItem, c as ListItemContent, b as ListItemIcon, S as StyledListItemContent } from './ListItemContent-24140036.js';
import { T as TestimonialCarousel } from './TestimonialCarousel-d7b8b145.js';
export { T as TestimonialCarousel, a as TestimonialItem } from './TestimonialCarousel-d7b8b145.js';
import { C as Countdown } from './Countdown-2a78cb7d.js';
export { C as Countdown } from './Countdown-2a78cb7d.js';
import { P as PopupV1 } from './PopupV1-b690a7d7.js';
export { P as PopupV1 } from './PopupV1-b690a7d7.js';
import { A as Accordion, a as AccordionItem, b as AccordionContent } from './AccordionContent-d99c16d6.js';
export { A as Accordion, b as AccordionContent, a as AccordionItem } from './AccordionContent-d99c16d6.js';
import { B as Box } from './Box-b0db6f27.js';
export { B as Box } from './Box-b0db6f27.js';
import { M as Map } from './Map-0164610a.js';
export { M as Map } from './Map-0164610a.js';
import { I as InputV1 } from './InputV1-5b6c6ce7.js';
export { I as InputV1 } from './InputV1-5b6c6ce7.js';
import { P as ProductList, a as ProductListContent } from './ProductListContent-f31bb715.js';
export { P as ProductList, a as ProductListContent, S as StoreProvider } from './ProductListContent-f31bb715.js';
import { P as PageFlip } from './PageFlip-35077923.js';
export { P as PageFlip } from './PageFlip-35077923.js';
import { S as SocialIcon } from './SocialIcon-e09781d3.js';
export { S as SocialIcon } from './SocialIcon-e09781d3.js';
import { C as ContentSlider, a as ContentSliderItem } from './ContentSliderItem-f505a145.js';
export { C as ContentSlider, a as ContentSliderItem } from './ContentSliderItem-f505a145.js';
import { S as StoreList } from './StoreList-c5fbcd50.js';
export { S as StoreList } from './StoreList-c5fbcd50.js';
import { N as NumberCounter } from './NumberCounter-b9f849cb.js';
export { N as NumberCounter } from './NumberCounter-b9f849cb.js';
import { b as ListItemV2, a as ListItemIconV2, L as ListItemContentV2 } from './listItemV2-6bdcbc84.js';
export { L as ListItemContentV2, a as ListItemIconV2, b as ListItemV2, S as StyledContent } from './listItemV2-6bdcbc84.js';
import { R as Root, P as PopupRoot } from './PopupRoot-2a0bc723.js';
export { P as PopupRoot, R as Root } from './PopupRoot-2a0bc723.js';
export { I as Input, a as InputNumber, S as StyledInput, T as Textarea } from './InputNumber-7d93e963.js';
export { Link } from './components/shared/Link.es.js';
export { O as Option, S as Select } from './Select-c8bcceda.js';
export { F as FormItem } from './FormItem-098fa619.js';
export { DateTimePicker } from './components/shared/DateTimePicker.es.js';
export { a as Radio, R as RadioGroup } from './RadioGroup-4b4abf08.js';
export { C as Col, R as Row, f as floorPercentage, p as percentage } from './Col-475038db.js';
export { D as DSSlider } from './Slider-93041044.js';
export { C as Container } from './Container-ca9f82d8.js';
export { D as Divider } from './Divider-600cb92e.js';
export { R as Ripple } from './Ripple-abf0f8a0.js';
export { D as DsImage } from './Image-efa43cf5.js';
export { a as Modal, d as ModalBody, c as ModalCloseIcon, M as ModalFooter, b as ModalHeader } from './ModalHeader-a3d30e4f.js';
export { S as Spin } from './Spin-a6892495.js';
export { CORE_SIZE, LandingLinks, MAPPING_ALIGNMENT_FLEX, MAPPING_VERTICAL_ALIGNMENT_FLEX, MAX_WIDTH, defaultTheme, landingLinks, reset } from './constants.es.js';
import { jsx } from 'react/jsx-runtime';
import 'tslib';
import 'rc-select';
import '@teko-builder/icons';
import '@teko-builder/types/pb';
export { D as DeviceTypes, g as generate, a as isMobile, i as isMobileOnly, b as textAnchorCss, t as themeColor } from './text-21866551.js';
import './DateTimePickerMobile-749dc497.js';
export { DEFAULT_ACCORDION, DEFAULT_BAR_STYLE, DEFAULT_BOX, DEFAULT_BUTTON, DEFAULT_BUTTON_STYLE, DEFAULT_CANCEL_BUTTON, DEFAULT_CIRCLE_STYLE, DEFAULT_COUNTDOWN, DEFAULT_DIVIDER, DEFAULT_DIVIDER_STYLE, DEFAULT_FORM, DEFAULT_FORM_STYLE, DEFAULT_HEADER, DEFAULT_HEADING, DEFAULT_ICON, DEFAULT_LIST, DEFAULT_LIST_DIVIDER, DEFAULT_LIST_DIVIDER_STYLE, DEFAULT_NUMBER_COUNTER, DEFAULT_NUMBER_STYLE, DEFAULT_OK_BUTTON, DEFAULT_PARAGRAPH, DEFAULT_POPUP, DEFAULT_PRODUCT_CARD, DEFAULT_SECTION_MARGIN_STYLE, DEFAULT_SLIDER, DEFAULT_SLIDER_V2, DEFAULT_STYLE, DEFAULT_TESTIMONIAL_CAROUSEL, DEFAULT_YOUTUBE } from './data.es.js';
export { u as useForm } from './useForm-aa144cb0.js';
export { getAnimation, getBackgroundOverlay, getBoxShadow, getCommonCss, getScrollbarWidth, getStyle, pixelParse, unitParse } from './utils.es.js';
export { a as addPaddingNumber, c as calculateTimeDelta, g as getIconCompoment, b as getParamsFromUrl, d as getPropsIcon, e as getSizeWithUnit } from './common-dbaafe9f.js';
export { c as constructGoogleImageParams, g as getImageUrlFromGoogleUserContent } from './image-1466e3c0.js';
export { c as convertOptionSliderV2ToV1 } from './slider-28e133c3.js';
export { fontQueryParams, pbFontFamily, pbFontWeight } from './fonts.es.js';
export { g as getRgbaFromHex } from './util-80df897f.js';
import 'react';
import '@emotion/styled';
import './translation-411fe6b6.js';
import 'react-google-recaptcha';
import 'react-google-recaptcha-v3';
import '@teko-builder/utils';
import 'react-hook-form';
import 'lodash.get';
import 'google-spreadsheet';
import 'classnames';
import './default_image-f8521c37.js';
import 'react-youtube';
import '@teko-builder/types/shared';
import 'dayjs';
import 'react-lazyload';
import '@teko-builder/plugin-teko-product';
import 'react-pageflip';
import 'react-circular-progressbar';
import '@emotion/react';
import 'rc-input-number';
import 'ua-parser-js';
import 'color-name';
import 'rc-picker';
import 'rc-picker/lib/generate/dayjs';
import 'rc-picker/lib/locale/vi_VN';
import 'dayjs/locale/vi';
import 'dayjs/plugin/customParseFormat';
import './constant-f622fb0e.js';
import './components/shared/BaseProps.es.js';
import 'swiper';
import 'swiper/react';
import 'react-dom';
import 'react-helmet';

const SubscriptionForm = (props) => {
    return jsx(FormV3, Object.assign({}, props));
};
SubscriptionForm.displayName = 'SubscriptionForm';
const listComponents = [
    Root,
    PbSection,
    PbContainer,
    PbRow,
    PbCol,
    Form,
    Heading,
    Paragraph,
    Youtube,
    Image,
    Spacer,
    Slider,
    SliderV2,
    PbDivider,
    ButtonV1,
    ButtonV2,
    Header,
    Logo,
    Menu,
    MenuItem,
    PbIcon,
    MenuCol,
    Tab,
    TabItem,
    HtmlCode,
    Countdown,
    List,
    ListItem,
    ListItemContent,
    ListItemIcon,
    Accordion,
    AccordionItem,
    AccordionContent,
    PopupV1,
    TestimonialCarousel,
    Map,
    FormV2,
    Box,
    InputV1,
    PageFlip,
    SocialIcon,
    ProductList,
    ProductListContent,
    ContentSlider,
    ContentSliderItem,
    FormV3,
    SubscriptionForm,
    StoreList,
    NumberCounter,
    PopupRoot,
    ListItemV2,
    ListItemIconV2,
    ListItemContentV2,
];
const componentDict = listComponents.reduce((acc, cur) => {
    const name = cur.displayName || cur.name;
    const key = name.toLowerCase();
    return Object.assign(Object.assign({}, acc), { [key]: cur });
}, {});

export { componentDict };
